import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CloudApiService } from './services/cloud-api.service';

export const superAdminGuard: CanActivateFn = async (route, state) => {
    const cloud = inject(CloudApiService);
    const router = inject(Router);

    // Wait for the cold-load session restore before judging auth state.
    await cloud.sessionReady;

    if (!cloud.isAuthenticated()) {
        if (!environment.production) {
            console.log('Not authenticated, redirecting to login');
        }
        return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    }

    const user = cloud.currentUser();
    if (user?.superAdmin) {
        if (!environment.production) {
            console.log('SuperAdmin access granted to', state.url);
        }
        return true;
    }

    if (!environment.production) {
        console.log('User is not a SuperAdmin, denying access to', state.url);
    }
    return router.createUrlTree(['/dashboard']);
};
